import { MouseEventHandler } from 'react';
import { Box } from '@rossum/ui/material';
import { EdgeResizingDirection } from '../utils/resizing';

/**
 * This is a presentational component that only renders an edge handle
 * It needs to be used within a PageSpaceContext that provides transformational functions
 */

const edgeHandleProps = {
  top: {
    x1: 0,
    x2: '100%',
    y1: 0,
    y2: 0,
    style: {
      cursor: 'ns-resize',
    },
  },
  right: {
    x1: '100%',
    x2: '100%',
    y1: 0,
    y2: '100%',
    style: {
      cursor: 'ew-resize',
    },
  },
  bottom: {
    x1: 0,
    x2: '100%',
    y1: '100%',
    y2: '100%',
    style: {
      cursor: 'ns-resize',
    },
  },
  left: {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: '100%',
    style: {
      cursor: 'ew-resize',
    },
  },
} as const;

type EdgeHandleProps = {
  direction: EdgeResizingDirection;
  color?: string;
  strokeWidth: number;
  onMouseDownCapture: MouseEventHandler<SVGLineElement>;
};

export const EdgeHandle = ({
  direction,
  color,
  strokeWidth,
  onMouseDownCapture,
}: EdgeHandleProps) => (
  <g>
    <Box
      component="line"
      {...edgeHandleProps[direction]}
      vectorEffect="non-scaling-stroke"
      color={color}
      strokeWidth={strokeWidth * 4}
      stroke="transparent"
      onMouseDownCapture={onMouseDownCapture}
      sx={{
        stroke: 'transparent',
        pointerEvents: 'all',
        [`&:hover ~ line`]: {
          stroke: color ?? (theme => theme.palette.primary.dark),
        },
      }}
    />
    <line
      {...edgeHandleProps[direction]}
      vectorEffect="non-scaling-stroke"
      strokeWidth={strokeWidth}
      pointerEvents="none"
    />
  </g>
);
